import { createAction } from '@reduxjs/toolkit'

export const getFilAddress = createAction<{ address: string, status: number}>('account/getFilAddress')
export const getDepositResult = createAction<string>('account/getDepositResult')
